import { useEffect } from 'react';

import { useAppStore, type IAppStore } from '@/store';
import useAuth from '@/hooks/useAuth';

const selector = (store: IAppStore) => ({ setCredits: store.setCredits });

/**
 * Clears the displayed credits when the user logs out. The credits number
 * is otherwise populated by useLibraryItemInfoMutation when a preset loads
 * — this hook just owns the logout-clear edge.
 */
const useCreditsSync = () => {
  const { isAuthorized } = useAuth();
  const { setCredits } = useAppStore(selector);

  useEffect(() => {
    if (!isAuthorized) setCredits(0);
  }, [isAuthorized, setCredits]);
};

export default useCreditsSync;
